export function formatRelativeDate(dateString) {
  const date = new Date(dateString);
  const now = new Date();

  // Calculate difference in days
  const diffTime = now - date; // in milliseconds
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

  // Same day?
  if (diffDays === 0) return "Today";

  // // Yesterday
  // if (diffDays === 1) return "Yesterday";

  // // Past few days
  // if (diffDays < 7) return `${diffDays} days ago`;

  // Otherwise, format as date

    // Custom formatted date: "24 Nov 2025"
  const day = date.getDate();
  const month = date.toLocaleString("en-US", { month: "short" }); // "Nov"
  const year = date.getFullYear();

  return `${day} ${month} ${year}`;
  // return date.toLocaleDateString(); // e.g., "11/21/2025"
}


const videoMimeTypeCache = new Map();

async function sniffContainerFormat(url) {
  // 'no-store' is required: the <video> thumbnail for this same URL loads it
  // in no-cors mode first, and the browser can reuse that opaque response for
  // a later same-URL fetch — which then fails CORS validation even though the
  // server sends correct Access-Control-Allow-Origin on a real network hit.
  const response = await fetch(url, {
    headers: { Range: 'bytes=0-11' },
    cache: 'no-store',
  });
  if (!response.ok) {
    throw new Error(`Range request failed with status ${response.status}`);
  }
  const bytes = new Uint8Array(await response.arrayBuffer());

  // WebM/Matroska: EBML header magic number
  if (bytes[0] === 0x1a && bytes[1] === 0x45 && bytes[2] === 0xdf && bytes[3] === 0xa3) {
    return 'video/webm';
  }
  // MP4/ISO-BMFF: bytes 4-7 spell "ftyp"
  if (
    bytes.length >= 8 &&
    bytes[4] === 0x66 && bytes[5] === 0x74 && bytes[6] === 0x79 && bytes[7] === 0x70
  ) {
    return 'video/mp4';
  }
  return null;
}

// Reads a video's first bytes to determine its real container format,
// since some interview clips were uploaded with a ".mp4" key/Content-Type
// even though the actual bytes are WebM. Returns null (rather than
// throwing) if detection isn't possible — e.g. the bucket's CORS policy
// doesn't allow this origin to read the file — callers treat that as "play
// it as mp4" rather than blocking on a definite answer. Results are cached
// per URL since the same clip is often re-opened (thumbnail preview, then
// the modal).
export async function detectVideoMimeType(url) {
  if (!url) return null;
  if (videoMimeTypeCache.has(url)) return videoMimeTypeCache.get(url);
  try {
    const type = await sniffContainerFormat(url);
    videoMimeTypeCache.set(url, type);
    return type;
  } catch (e) {
    return null;
  }
}

// Synchronous cache peek — use this to choose a <video>'s initial source so
// it can mount immediately (in the same tick as a click handler). Autoplay
// with sound is only allowed by browsers when it happens as a direct,
// synchronous continuation of a user gesture; awaiting detectVideoMimeType
// before first mount pushes the <video> element's creation outside that
// window and silently breaks autoplay.
export function getCachedVideoMimeType(url) {
  return videoMimeTypeCache.get(url) ?? null;
}